export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-foreground-300 pt-12 md:pt-16 pb-6">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-lg text-white"></i>
              </div>
              <span className="font-heading text-lg font-extrabold text-foreground-100">
                屁屁影院
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              高清免费在线观影平台，海量影视资源即点即播，不缓冲流畅追剧。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-100 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#hero" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  首页
                </a>
              </li>
              <li>
                <a href="#ranking" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  热播排行
                </a>
              </li>
              <li>
                <a href="#carousel" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  焦点大片
                </a>
              </li>
              <li>
                <a href="#comments" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  用户热评
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-100 mb-4">
              帮助中心
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#faq" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  常见问题
                </a>
              </li>
              <li>
                <a href="#about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  关于我们
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  联系我们
                </a>
              </li>
              <li>
                <a href="#app" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  APP下载
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-100 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              合作伙伴信息即将上线
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800/30 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2025 屁屁影院 - 高清免费在线观看不缓冲。本站内容仅供学习交流。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">
              服务条款
            </a>
            <a href="#hero" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#contact" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">
              投诉建议
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}